import { getExecutorsJsonSchema } from '../http/trading-ws/schemas';
import type { UseQueryOptions } from '@tanstack/react-query';

export const TRADING_SCHEMAS = 'trading-schemas';

export const getExecutorsJsonSchemaQuery = (
    account?: string,
): UseQueryOptions<Awaited<ReturnType<typeof getExecutorsJsonSchema>>> => {
    return {
        queryKey: [TRADING_SCHEMAS, account],
        queryFn: () => getExecutorsJsonSchema({ account: account! }),
        refetchInterval: 1_000 * 60, // 1 minute
        refetchIntervalInBackground: true,
        enabled: Boolean(account),
        staleTime: Number.POSITIVE_INFINITY,
    };
};
